import { Pipe, PipeTransform } from '@angular/core';
import { map, startWith } from 'rxjs/operators';
@Pipe({
  name: 'courseFilter',
  pure: false
})
export class CourseFilterPipe implements PipeTransform {

  transform(value: any, filterString: string, propName: string): any {
    const resultArray = [];
    if (value.length === 0 || filterString === '') {
      return value;
    }
    for (const item of value) {
      if (item[propName].toLowerCase().includes(filterString.toLowerCase())) {
        resultArray.push(item);
      }
    }
    return resultArray;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-dashboard/user-dashboardcards/course-filter.pipe.ts